module.exports = __webpack_public_path__ + "assets/img/places.6f5d65c4.jpg";